import { render, staticRenderFns } from "./AddZoom.vue?vue&type=template&id=564a1c8e&"
import script from "./AddZoom.vue?vue&type=script&lang=js&"
export * from "./AddZoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports